import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex'

import { BootstrapVue } from 'bootstrap-vue'

import 'bootstrap'
import './assets/bootstrap/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/bootstrap-icons/bootstrap-icons.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/style/main.css'
import './assets/style/override.css'
import './assets/style/custom.css'
import VueMasonry from 'vue-masonry-css'
import VShowSlide from 'v-show-slide'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueSweetalert2 from 'vue-sweetalert2'
import Toasted from 'vue-toasted'
import 'sweetalert2/dist/sweetalert2.min.css'
import './assets/js/main.js'
import './assets/js/vendor/bootstrap/js/bootstrap.bundle.js'/*  */
import axios from 'axios';

// window.$ = window.jQuery = require('jquery');

Vue.config.productionTip = false
// Vue.prototype.$endpoints = {
// 	user: (process.env.NODE_ENV === 'development') ? 'https://sisdaum.jasatirta2.co.id/':'https://sisdaum.jasatirta2.co.id/',
// 	reference: (process.env.NODE_ENV === 'development') ? 'https://sisdarf.jasatirta2.co.id/':'https://sisdarf.jasatirta2.co.id/',
// 	sarpras: (process.env.NODE_ENV === 'development') ? 'https://sisdasp.jasatirta2.co.id/':'https://sisdasp.jasatirta2.co.id/',
// 	operasi: (process.env.NODE_ENV === 'development') ? 'https://sisdaop.jasatirta2.co.id/':'https://sisdaop.jasatirta2.co.id/',
// 	telemeteri: (process.env.NODE_ENV === 'development') ? 'https://sisdatm.jasatirta2.co.id/':'https://sisdatm.jasatirta2.co.id/',
// 	spatial: (process.env.NODE_ENV === 'development') ? 'https://sisdatm.jasatirta2.co.id/api/':'https://sisdatm.jasatirta2.co.id/api/',
// 	geomoss: (process.env.NODE_ENV === 'development') ? 'https://sisdagj.jasatirta2.co.id/api':'https://sisdagj.jasatirta2.co.id/api',
// 	scada: (process.env.NODE_ENV === 'development') ? 'https://scada.jasatirta2.id/api':'https://scada.jasatirta2.id/api',
// 	sistarum: (process.env.NODE_ENV === 'development') ? 'https://sisdascd.jasatirta2.co.id/api':'https://sisdascd.jasatirta2.co.id/api',
// 	watermeter: (process.env.NODE_ENV === 'development') ? 'https://sisdawm.jasatirta2.co.id/api':'https://sisdawm.jasatirta2.co.id/api',
// };

Vue.prototype.$endpoints = {
	user: (process.env.NODE_ENV === 'development') ? 'https://user.jasatirta2.id/':'https://user.jasatirta2.id/',
	reference: (process.env.NODE_ENV === 'development') ? 'https://reference.jasatirta2.id/':'https://reference.jasatirta2.id/',
	sarpras: (process.env.NODE_ENV === 'development') ? 'https://sarpras.jasatirta2.id/':'https://sarpras.jasatirta2.id/',
	operasi: (process.env.NODE_ENV === 'development') ? 'https://operation.jasatirta2.id/':'https://operation.jasatirta2.id/',
	telemeteri: (process.env.NODE_ENV === 'development') ? 'https://telemetri.jasatirta2.id/':'https://telemetri.jasatirta2.id/',
	spatial: (process.env.NODE_ENV === 'development') ? 'https://spasial.jasatirta2.id/api/':'https://spasial.jasatirta2.id/api/',
	geomoss: (process.env.NODE_ENV === 'development') ? 'http://localhost:8000/api':'https://bendungan.jasatirta2.id/api',
	scada: (process.env.NODE_ENV === 'development') ? 'https://scada.jasatirta2.id/api':'https://scada.jasatirta2.id/api',
	sistarum: (process.env.NODE_ENV === 'development') ? 'http://localhost:3000/api':'https://sistarum.jasatirta2.id/api',
	watermeter: (process.env.NODE_ENV === 'development') ? 'http://localhost:3000/api':'https://wm.jasatirta2.id/api',
	conservation: (process.env.NODE_ENV === 'development') ? 'http://localhost:3000/api':'https://conservation.jasatirta2.id/api',
	ffws: (process.env.NODE_ENV === 'development') ? 'http://localhost:3002/api':'https://ffws.jasatirta2.id/api',
	wq: (process.env.NODE_ENV === 'development') ? 'https://wq.jasatirta2.id/api':'https://wq.jasatirta2.id/api',
};

Vue.prototype.$refresh_duration = 60000; // auto fetch data every 1 minute

Vue.use(VueGoogleMaps, {
	load:{
		key: 'AIzaSyDdIMFgCkeCb45CXklYYp9j_5jZrTHi6ow',
		libraries: 'places'
	}
});
Vue.use(VueMasonry);
Vue.use(VShowSlide);
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(Toasted)
Vue.use(Vuex)

Vue.mixin({
	methods:{
		logout: function(){
			const isWebView = /MyAppWebView/i.test(navigator.userAgent)

            localStorage.removeItem('token');
            localStorage.removeItem('role');
            localStorage.removeItem('org_id');
            localStorage.removeItem('name');
            localStorage.removeItem('id');
            localStorage.removeItem('isAuthenticated');

			this.$router.push({path: isWebView ? '/login' : '/'});
		},
		createFormData: function(data){
			let fd = new FormData();

			for(var key in data){
				if(data[key] !== null){
					fd.append(key, data[key]);
				}
			}

			return fd;
		},
		doLogin: function(event){
			const isWebView = /MyAppWebView/i.test(navigator.userAgent)
			let fd = new FormData();

			// Request Form
			fd.append('username', this.username);
			fd.append('password', this.password);

			// Loading
			this.is_loading = true;

			// API 
			axios.post(this.$endpoints.user+'login', fd,{
				headers:{'Content-type':'multipart/form-data'}
			}).then(response => {
				localStorage.setItem('name', response.data.name);
				localStorage.setItem('id', response.data.id);
				localStorage.setItem('role', response.data.role);
				localStorage.setItem('org_id', response.data.ref_org_id);
				localStorage.setItem('module_access', response.data.module_access);

				// Patokan
				localStorage.setItem('token', response.data.access_token);
				
				this.$router.push({path: isWebView ? '/sem-dashboard':'/dashboard'});
			}).catch(() => {
                this.$swal('User atau password yang anda masukan salah');
			});

			event.preventDefault();
        },
        getRole: () => {
            return localStorage.getItem('role')
        },
		dmsToDd(input) {
			if (typeof input === "number") {
				return input; // kalau udah number
			}

			if(input === null){
				return input;
			}
		
			// Hilangkan spasi ekstra
			input = input.replace(/\s/g, '').trim();
		
			// Cek apakah sudah decimal (misal "107.375506" atau "-6.572039")
			if (/^-?\d+(\.\d+)?$/.test(input)) {
				return parseFloat(input);
			}
		
			// Regex DMS: contoh "107°22'31.82\"E" atau "6°34'19.34\"S" atau "107°22'31.82E"
			const regex = /(\d+)°(\d+)'([\d.]+)"?([NSEW])/i;
			const match = input.match(regex);
		
			if (!match) {
				throw new Error("Format koordinat tidak dikenali: " + input);
			}
		
			let degrees = parseFloat(match[1]);
			let minutes = parseFloat(match[2]);
			let seconds = parseFloat(match[3]);
			let direction = match[4].toUpperCase();
		
			let decimal = degrees + (minutes / 60) + (seconds / 3600);
		
			if (direction === "S" || direction === "W") {
				decimal = -decimal;
			}
		
			return decimal;
		}
	},
})

const store = new Vuex.Store({
	state:{
		authenticated: false,
	},
	mutations:{
		setAuthentication(state, status){
			state.authenticated = status
		}
	}
})

new Vue({
	router,
	store: store,
	render: h => h(App),
}).$mount('#app')
